<template>
  <div style="display: flex; justify-content: center">
    <Section illust_title="最新插画" :imageData="imageInfos_new"></Section>
  </div>

  <div style="display: flex; justify-content: center;">
    <paginater :count="count" :type="0" @pageChange="pageChange"></paginater>
  </div>
</template>
<script>
import Section from '@/components/Section copy.vue';
import paginater from '@/components/paginater.vue';

export default {
  name: 'Search',
  data() {
    return {
      imageInfos_new: [],
      count: 8,
      input1: '',
      tag: this.$route.query.tag,
    }
  },
  components: {
    Section,
    paginater,
  },
  methods: {
    loadData(offset) {
      var url = "https://www.vilipix.com/api/v1/picture/public?limit=30&tags=" + this.tag + "&from=pc_web&sort=new&offset=" + (offset * 30);
      this.$axios.get(url).then(res => {
        this.imageInfos_new = res.data.data.rows;
        this.count = res.data.data.count;
        console.log(this.tag);
      }).catch(error => {
        console.log(error);
      })
    },

    pageChange(offset) {
      this.loadData(offset)
    }
  },
  created() {
    this.loadData(0);
  },
  watch: {
    '$route'(to, from) {
      console.log('onroutr', this.$route.query);
      this.tag = this.$route.query.tag
      this.loadData(0);
    }
  }
}
</script>